<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer004">
<p class="CN ParaOverride-1" id="_idParaDest-1"> </p>
<div class="_idGenObjectLayout-1">
<div id="_idContainer000">
<img alt="" class="_idGenObjectAttribute-1" src="image/1979TitleType.jpg"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802159038.vue?ad364c2c